var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sunny",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flat_final",
    "data-name": "Flat final",
    transform: "translate(7.714 7.714)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 10.786,
    cy: 10.786,
    r: 10.786,
    fill: "#f9ae00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M108.254,96.745a11.509,11.509,0,1,0,11.509,11.509A11.522,11.522,0,0,0,108.254,96.745Zm0,21.572a10.063,10.063,0,1,1,10.063-10.063A10.075,10.075,0,0,1,108.254,118.317Z",
    transform: "translate(-89.754 -89.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M246.723,4.863a.723.723,0,0,0,.723-.723V.723a.723.723,0,0,0-1.445,0V4.14A.723.723,0,0,0,246.723,4.863Z",
    transform: "translate(-228.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M246.723,444.707a.723.723,0,0,0-.723.723v3.418a.723.723,0,0,0,1.445,0V445.43A.723.723,0,0,0,246.723,444.707Z",
    transform: "translate(-228.223 -412.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M124.8,37a.723.723,0,0,0,1.252-.723l-1.709-2.96a.723.723,0,1,0-1.252.723Z",
    transform: "translate(-114.11 -30.575)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M346.7,418.445a.723.723,0,0,0-1.252.723l1.709,2.96a.723.723,0,1,0,1.252-.723Z",
    transform: "translate(-320.395 -387.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M37,124.8,34.04,123.1a.723.723,0,1,0-.723,1.252l2.96,1.709A.723.723,0,0,0,37,124.8Z",
    transform: "translate(-30.575 -114.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M422.127,347.157l-2.96-1.709a.723.723,0,0,0-.723,1.252l2.96,1.709a.723.723,0,1,0,.723-1.252Z",
    transform: "translate(-387.87 -320.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M4.863,246.723A.723.723,0,0,0,4.14,246H.723a.723.723,0,0,0,0,1.445H4.14A.723.723,0,0,0,4.863,246.723Z",
    transform: "translate(0 -228.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M448.847,246H445.43a.723.723,0,1,0,0,1.445h3.418a.723.723,0,0,0,0-1.445Z",
    transform: "translate(-412.57 -228.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M36.278,345.448l-2.96,1.709a.723.723,0,0,0,.723,1.252L37,346.7a.723.723,0,0,0-.723-1.252Z",
    transform: "translate(-30.575 -320.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M418.81,126.153a.719.719,0,0,0,.361-.1l2.96-1.709a.723.723,0,0,0-.723-1.252l-2.96,1.709a.723.723,0,0,0,.362,1.349Z",
    transform: "translate(-387.873 -114.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M125.791,418.181a.723.723,0,0,0-.987.264L123.1,421.4a.723.723,0,1,0,1.252.723l1.709-2.96A.723.723,0,0,0,125.791,418.181Z",
    transform: "translate(-114.11 -387.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M345.713,37.265A.723.723,0,0,0,346.7,37l1.709-2.96a.723.723,0,0,0-1.252-.723l-1.709,2.96A.723.723,0,0,0,345.713,37.265Z",
    transform: "translate(-320.395 -30.575)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.78e0917609e039e2696b78fe596612b9.svg";
export { ForwardRef as ReactComponent };